import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { crearQueryClient } from './api/queryClient';
import './estilos.css';

const raiz = document.getElementById('root');
if (!raiz) {
  throw new Error('Falta el <div id="root"> en index.html');
}

// El <BrowserRouter> vive acá y no en App para que los tests monten las mismas
// rutas con un <MemoryRouter> y puedan entrar por cualquier URL.
createRoot(raiz).render(
  <StrictMode>
    <QueryClientProvider client={crearQueryClient()}>
      {/* Los `future` son el comportamiento de React Router v7, activado ya
          para no arrastrar una migración pendiente (y para que el router deje
          de avisarlo por consola en cada arranque). */}
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
